import { createSlice } from "@reduxjs/toolkit";

const initiallibraryState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  libraryForEdit: undefined,
  lastError: null,
  // ! PROGRAM, DONOR, DONATION COUNT
  donorCount: 0,
  donationCount: 0,
  programCount: 0,
  // ? LIBRARY FILES
  libraryFiles: []
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const organizationLibrarySlice = createSlice({
  name: "library",
  initialState: initiallibraryState,
  reducers: {
    catchError: (state, action) => {
      state.listLoading = false;
      state.actionsLoading = false;
      // state.error = `${action.type}: ${action.payload.error}`;
      // if (action.payload.callType === callTypes.list) {
      //   state.listLoading = false;
      // } else {
      //   state.actionsLoading = false;
      // }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    // getlibraryById
    libraryFetched: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.libraryForEdit = action.payload.libraryForEdit;
      state.donorCount = action.payload.donorCount;
      state.donationCount = action.payload.donationCount;
      state.programCount = action.payload.programCount;
    },
    // findlibrary
    librarysFetched: (state, action) => {
      const { total_items, items } = action.payload;
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
      state.entities = items;
      state.totalCount = total_items;
    },
    // Set to default state actionLoading & error
    libraryReload: (state, action) => {
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
    },
    libraryFiles: (state, action) => {
      state.libraryFiles = action.payload.items;
      state.totalCount = action.payload.total_items;
      state.listLoading = false;
      state.actionsLoading = false;
    },
    libraryFilesFetched: (state, action) => {
      state.libraryFiles = action.payload.items;
      state.listLoading = false;
      state.actionsLoading = false;
    }
  }
});
